import { motion } from 'framer-motion';
import { Heart, Cake, Building2, Users } from 'lucide-react';

const EVENT_TYPES = [
  {
    category: 'Hochzeit',
    icon: Heart,
    description: 'Magische Momente für den schönsten Tag',
    color: 'from-pink-500 to-rose-500'
  },
  {
    category: 'Geburtstag',
    icon: Cake,
    description: 'Party-Spaß für alle Altersgruppen',
    color: 'from-amber-500 to-orange-500'
  },
  {
    category: 'Firmenevent',
    icon: Building2,
    description: 'Teambuilding mit Spaßfaktor',
    color: 'from-blue-500 to-indigo-500'
  },
  {
    category: 'Vereinsfest',
    icon: Users,
    description: 'Gemeinsam feiern, gemeinsam lachen',
    color: 'from-emerald-500 to-teal-500'
  }
];

export const EventsSection = () => {
  return (
    <section id="events" className="py-16 md:py-20 px-6 bg-white" data-testid="events-section">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-[#3ECDC3] font-semibold text-sm tracking-widest uppercase block mb-4">
            Ein Hingucker für Ihr Event
          </span>
          <h2 
            className="text-4xl md:text-5xl font-bold tracking-tight text-gray-900"
            
            data-testid="events-headline"
          >
            Für jeden Anlass<br />
            <span className="text-[#3ECDC3]">die richtige Box</span>
          </h2>
        </motion.div>

        {/* Event Cards Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="events-grid">
          {EVENT_TYPES.map((event, index) => {
            const IconComponent = event.icon;
            return (
              <motion.div
                key={event.category}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="group relative bg-white rounded-2xl p-8 border border-gray-200 hover:border-[#3ECDC3] hover:shadow-xl transition-all duration-500 cursor-pointer overflow-hidden"
                data-testid={`event-card-${event.category.toLowerCase()}`}
              >
                {/* Background Gradient on Hover */}
                <div className={`absolute inset-0 bg-gradient-to-br ${event.color} opacity-0 group-hover:opacity-5 transition-opacity duration-500`} />
                
                {/* Icon */}
                <div className={`relative w-16 h-16 rounded-2xl bg-gradient-to-br ${event.color} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-500`}>
                  <IconComponent className="w-8 h-8 text-white" />
                </div>
                
                {/* Content */}
                <h3 
                  className="relative text-xl font-bold text-gray-900 mb-3 group-hover:text-[#3ECDC3] transition-colors"
                  
                >
                  {event.category}
                </h3>
                <p className="relative text-gray-500 text-sm leading-relaxed">
                  {event.description}
                </p>
                
                {/* Bottom Accent Line */}
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-[#3ECDC3] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
